/* This component CREATES one entry for the historys collection in MongoDB.
   As the entry is being CREATED, it should then activate the HistoryRead component
   to show the entry as it is being built. */

import React, { useEffect, useState }  from 'react'
import axios                           from 'axios'
import Box                             from "@material-ui/core/Box"
import {
   Button,
   Grid,
   TextField,
   TextareaAutosize,
   Typography }                     from '@material-ui/core'

import HistoryReadComponent         from './HistoryReadComponent'
import PhotoSearchComponent         from './PhotoSearchComponent'

import {
   CLIENT_PUBLIC_TOKEN,
   historyRadioOptions
}                                   from '../config'

import { node_server }              from '../Helpers'

const HistoryCitationReadComponent = () => {

   const [ citations,   setCitations   ]  =  useState([])

   useEffect( () => {
console.log('HistoryCitationComponent useEffect is running')
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      axios.get(node_server + 'historyCitation')
      .then( res => res.data )
      .then( data => {
               console.log('HistoryCitationReadComponent data is', data)
         setCitations(data.entry.map( c => {
            return(
               <Typography key={c._id} align='left' >
                  [ { c.citation_number } ] {c.citation}
               </Typography>
            )
         }))
      })
      .catch( (error) => {
         console.error(error)
      })

   }, [])

   return (
      <Box >
         <Grid style={{ padding: '2rem' }} >
            { citations }
         </Grid>
      </Box>
   )
}

export default HistoryCitationReadComponent
